import React from "react";
import {useTranslation} from "react-i18next";
import {useProductListContext} from "../organisms/productListProvider/ProductListProvider";

const ResetFiltersLink: React.FC = () => {
  const {t} = useTranslation();
  const {dispatch} = useProductListContext();

  const resetAllFilter = () => {
    dispatch({type: "RESET"});
    dispatch({type: "TRIGGER"});
  };

  return (
    <span className="filter-reset__link" role="link" onClick={resetAllFilter}>
      {t("product.resetAllFilters")}
      <span className="icon icon-back--blue" />
    </span>
  );
};

export default ResetFiltersLink;
